import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "success", "announcement"];

  static values = {
    copiedMessage: String,
  };

  declare sourceTarget: HTMLElement;
  declare successTarget: HTMLElement;
  declare announcementTarget: HTMLElement;
  declare hasAnnouncementTarget: boolean;
  declare copiedMessageValue: string;

  copy() {
    const copiedText = this.sourceTarget.textContent.trim();
    navigator.clipboard.writeText(copiedText);
    this.show();
  }

  show() {
    this.successTarget.dataset.success = "true";

    if (this.hasAnnouncementTarget) {
      this.announcementTarget.textContent = this.copiedMessageValue;
    }

    setTimeout(() => {
      this.successTarget.dataset.success = "false";

      if (this.hasAnnouncementTarget) {
        this.announcementTarget.textContent = "";
      }
    }, 3000);
  }
}
